import { FC, useContext, useEffect } from 'react';
import { AuthContext, Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Select } from 'components/form/Select';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { ScFieldExpiryDateRow } from './styled';
import { useFieldApi, useFieldState } from 'informed';
import { useCurrentRoute } from 'react-navi';

const MARGIN_BOTTOM_FLEXEPIN = 8;
const MARGIN_BOTTOM = 0;

const AMOUNT = 'amountValue';
const CASH_TO_CODE_PAYMENT_METHOD = 'devcode_devcode-funanga-94_funanga';
const FLEXEPIN_PAYMENT_METHOD = 'devcode_devcode-flexepin-55_flexepin';

export const FieldSelect: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Select]
> = ({ fieldName, placeholder, label, options }) => {
  const fieldState = useFieldState(fieldName);
  const fieldApi = useFieldApi(fieldName);
  const { setCurrentAmount, currentPaymentMethodId } = useContext(AuthContext);
  const {
    url: { query },
  } = useCurrentRoute();

  const isAmountField = fieldName.includes(AMOUNT);

  const isCashToCode = currentPaymentMethodId?.includes(
    CASH_TO_CODE_PAYMENT_METHOD
  );
  const isFlexepin = currentPaymentMethodId?.includes(FLEXEPIN_PAYMENT_METHOD);

  const optionsFormatted = options.map(({ label, value }) => ({
    name: label,
    value,
  }));

  const lastIndexOfTheArray = optionsFormatted[optionsFormatted.length - 1];

  useEffect(() => {
    if (!isAmountField) return;

    const hasValue = !!fieldState?.value;
    const secondOption = optionsFormatted[1];

    if (query.vip && (isCashToCode || isFlexepin) && lastIndexOfTheArray) {
      fieldApi.setValue(lastIndexOfTheArray.value);
      setCurrentAmount(Number(lastIndexOfTheArray.value));
      return;
    }

    if (
      !hasValue &&
      secondOption &&
      (isCashToCode || isFlexepin) &&
      !query.vip
    ) {
      fieldApi.setValue(secondOption.value);
      setCurrentAmount(Number(secondOption.value));
      return;
    }

    if (!hasValue) {
      setCurrentAmount('');
    } else {
      setCurrentAmount(Number(fieldState.value));
    }
  }, [
    isAmountField,
    isCashToCode,
    isFlexepin,
    fieldState?.value,
    fieldApi,
    optionsFormatted,
    setCurrentAmount,
    query?.vip,
    lastIndexOfTheArray,
  ]);

  return (
    <FormGroup
      title={label || undefined}
      marginBottom={isFlexepin ? MARGIN_BOTTOM_FLEXEPIN : MARGIN_BOTTOM}
    >
      <ScFieldExpiryDateRow $list>
        <Select
          field={fieldName}
          placeholder={placeholder || label || fieldName}
          options={optionsFormatted}
          validate={required}
          validateOnBlur
        />
      </ScFieldExpiryDateRow>
    </FormGroup>
  );
};
